import * as actionTypes from './actionTypes';

const initialState = {
  value: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LEAGUE_TABLE_SEARCH_STATE:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.RESET_LEAGUE_TABLE_FILTERS_SEARCH:
      return initialState;
    default:
      return state;
  }
};
